import { render, staticRenderFns } from "./ModalCreateNewIndividualPlan.vue?vue&type=template&id=37fcc2ce&scoped=true&"
import script from "./ModalCreateNewIndividualPlan.vue?vue&type=script&lang=js&"
export * from "./ModalCreateNewIndividualPlan.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateNewIndividualPlan.vue?vue&type=style&index=0&id=37fcc2ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fcc2ce",
  null
  
)

export default component.exports